import {
    IPropertyChild,
    PropertyValueType,
} from '@kcftech/prometheustypescriptapiclient';
import { RadioButtonItem } from 'components/forms/RadioButtonGroup';
import { RegisterOptions } from 'react-hook-form';
import { isValidInteger, isValidNumber } from 'utils/number';

export const parameterMaxLength = 200;

export const booleanRadioOptions: RadioButtonItem<'true' | 'false'>[] = [
    { label: 'False', value: 'false' },
    { label: 'True', value: 'true' },
];

export const supportedPropertyValueTypes = [
    PropertyValueType.Double,
    PropertyValueType.Float,
    PropertyValueType.Integer,
    PropertyValueType.String,
    PropertyValueType.Boolean,
];

export const getParameterInputRules = (property: IPropertyChild): RegisterOptions => ({
    validate: (value) => {
        const trimmedValue = value?.trim() ?? '';
        if (!trimmedValue) {
            if (property.PropertyRequired) {
                return `${property.PropertyName} is required.`;
            }
            return undefined;
        }

        if (trimmedValue.length > parameterMaxLength) {
            return `${property.PropertyName} cannot exceed ${parameterMaxLength} characters.`;
        }
        switch (property.PropertyValueType) {
            case PropertyValueType.Double:
            case PropertyValueType.Float:
                return !isValidNumber(value)
                    ? `${property.PropertyName} must be a number.`
                    : undefined;
            case PropertyValueType.Integer:
                return !isValidInteger(value)
                    ? `${property.PropertyName} must be an integer.`
                    : undefined;
            default:
                return undefined;
        }
    },
});
